import {ObjectOfStrings} from '../../types';

export const removeTrailingSlash = (path: string): string => {
  const hasTrailingSlash = path.slice(-1) === '/';
  return hasTrailingSlash ? path.slice(0, -1) : path;
};

export const replaceParamFragments = (template: string, params: ObjectOfStrings, namespace?: string): string => {
  let formattedValue = template;

  Object.entries(params).forEach(([key, value]) => {
    const regexp = new RegExp(`{${namespace ? `${namespace}\\.` : ''}${key}}`, 'gi');
    formattedValue = formattedValue.replace(regexp, value);
  });

  // check for missed fragments in namespace
  const validateRegexp = new RegExp(`{${namespace ? `${namespace}\\.` : ''}\\w+}`, 'i');
  if (formattedValue.match(validateRegexp)) {
    throw new Error(`Fragments${namespace ? ` in namespace "${namespace}"` : ''} not replaced: "${formattedValue}"`);
  }

  return formattedValue;
};

export const formatObjectToQueryString = (params: ObjectOfStrings): string => {
  const qs = new URLSearchParams(params);
  return qs.toString() ? `?${qs}` : '';
};
